import React from 'react'
import parse from 'html-react-parser'
import { Fade } from 'react-reveal'

const Quote = ({ quote }) => {

  return (
    <section className='quote'>
      <Fade bottom distance='40px'>
        <div className='quote__inner'>
          <div className='quote__content'>
            { quote && <h3>{ parse(quote) }</h3> }
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default Quote